import { Swiper } from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { strlSetSliderPaginationAriaLabels } from '../../src/js/components/a11y';

import 'swiper/css';

let cardsSliders = [];

function cardsSwiper() {
	const cardsSliderSection = document.querySelectorAll('section.cards-overview');
	const screenWidth = window.innerWidth;

	cardsSliderSection.forEach((slider, index) => {
		const sliderWrapper = slider.querySelector('.cards-overview-slider');
		if (sliderWrapper) {
			const rowIndex = slider.getAttribute('data-row-index');
			let breakpoints = {};

			breakpoints = {
				320: {
					slidesPerView: 1.3,
					spaceBetween: 24,
				},
			};

			if (screenWidth < 640) {
				if (!cardsSliders[index]) {
					cardsSliders[index] = new Swiper(sliderWrapper, {
						modules: [Navigation, Pagination],
						resizeObserver: true,
						a11y: {
							enabled: true,
							slideRole: '',
						},
						spaceBetween: 32,
						loop: true,
						allowTouchMove: true,
						slidesPerView: 1.3,
						navigation: {
							nextEl: '[data-row-index="' + rowIndex + '"] .swiper-btn-next',
							prevEl: '[data-row-index="' + rowIndex + '"] .swiper-btn-prev',
						},
						keyboard: {
							enabled: true,
							onlyInViewport: true,
						},
						breakpoints,
						runCallbacksOnInit: true,
						on: {
							init: function () {
								const activeSlide = slider.querySelector('.swiper-slide-active');

								if (activeSlide) {
									activeSlide.classList.add('start-transition');
								}

								const totalSlides = this.slides.length;
								document.querySelector(
									'[data-row-index="' + rowIndex + '"] .slide-count-wrapper .total'
								).innerHTML = totalSlides;
							},

							slidePrevTransitionEnd: function () {
								const totalSlides = cardsSliders[index].slides.length;
								let currentSlide = this.realIndex + 1 < totalSlides ? this.realIndex + 1 : totalSlides;
								slider.querySelector('.slide-count-wrapper .current').innerHTML = currentSlide;
							},

							slideNextTransitionEnd: function () {
								const totalSlides = cardsSliders[index].slides.length;
								let currentSlide = this.realIndex + 1 > totalSlides ? 1 : this.realIndex + 1;
								slider.querySelector('.slide-count-wrapper .current').innerHTML = currentSlide;
							},
						},
					});
				}
			} else {
				if (cardsSliders[index]) {
					cardsSliders[index].destroy(true, true);
					cardsSliders[index] = null;
				}
			}
		}
	});

	strlSetSliderPaginationAriaLabels();
}
cardsSwiper();
window.addEventListener('resize', cardsSwiper);
